import { bblApi } from 'api/bbl'
import { boardApi } from 'api/board'
import { clientApi } from 'api/client'
import { emptySplitApi as portalApi } from 'api/emptyApi'
import { mergefieldApi } from 'api/mergefield'
import { resetBBLArchiveFilters } from 'Modules/Boardwork/DocumentArchive/BblArchive/BblArchiveSlice'
import { resetBoardArchiveFilters } from 'Modules/Boardwork/DocumentArchive/BoardArchive/BoardArchiveSlice'
import { resetMeetingsFilters } from 'Modules/Boardwork/Meetings/shared/store/meetingsFilters'
import { resetSubleaseFilters } from 'Modules/Boardwork/Tasks/Sublease/shared/store/subleaseFilters'
import { resetContactsFilters } from 'Modules/Communication/Contacts/shared/store/contactsFilters'
import { resetNoticesFilters } from 'Modules/Communication/Notices/shared/store/noticesFilters'
import { resetBudgetState } from 'Modules/Economy/Budget/shared/store/budgetSlice'
import { resetInsuranceAgreementsFilters } from 'Modules/HousingAssociation/Insurance/shared/store/insuranceAgreementsFilters'
import { resetInsuranceCasesFilters } from 'Modules/HousingAssociation/Insurance/shared/store/insuranceCasesFilters'
import { resetUnitsFilters } from 'Modules/HousingAssociation/OurCompany/shared/store/unitsFilters'
import { resetTenantsFilters } from 'Modules/HousingAssociation/Tenants/shared/store/tenantsFilters'
import { LOCAL_STORAGE_CLIENT_ID } from 'shared/constants/localStorageVariables'
import { setActiveClientIdStarted, setActiveClientId } from '.'
import { updateEmailFilters } from '../communication/emails'
import { setSmsFilters } from '../communication/smsMessages'
import loanApi from '../economy/loan/loan.service'
import { emptySplitApi } from '../emptyApi'
import type { AppDispatch } from '../hooks'
import menuApi from '../menu/menu.service'

export const setActiveClient = async (
  dispatch: AppDispatch,
  clientId?: string
) => {
  if (!clientId) return

  dispatch(setActiveClientIdStarted())

  localStorage.setItem(LOCAL_STORAGE_CLIENT_ID, clientId)

  await dispatch(menuApi.endpoints.getMenu.initiate(clientId))

  dispatch(boardApi.endpoints.getBoards.initiate({}))

  dispatch(loanApi.endpoints.getPendingInterestRateChanges.initiate(clientId))

  dispatch(
    updateEmailFilters({
      labelId: '',
      onlyUnread: false,
      dates: {
        received: { from: undefined, to: undefined },
        sent: { from: undefined, to: undefined },
        deleted: { from: undefined, to: undefined },
        processed: { from: undefined, to: undefined },
      },
    })
  )
  dispatch(setSmsFilters({ labelId: '' }))

  dispatch(setActiveClientId(clientId))
  dispatch(resetBudgetState())
  dispatch(resetBoardArchiveFilters())
  dispatch(resetBBLArchiveFilters())
  dispatch(resetInsuranceAgreementsFilters())
  dispatch(resetInsuranceCasesFilters())
  dispatch(resetContactsFilters())
  dispatch(resetNoticesFilters())
  dispatch(resetUnitsFilters())
  dispatch(resetTenantsFilters())
  dispatch(resetMeetingsFilters())
  dispatch(resetSubleaseFilters())

  dispatch(portalApi.util.resetApiState())
  dispatch(emptySplitApi.util.resetApiState())

  dispatch(mergefieldApi.endpoints.getTerminology.initiate({ clientId }))

  await Promise.all([
    dispatch(bblApi.endpoints.getBbl.initiate()),
    dispatch(clientApi.endpoints.getClientsById.initiate({ id: clientId })),
    dispatch(
      clientApi.endpoints.getClientsByIdSettings.initiate({ id: clientId })
    ),
  ])
}
